export const postViewerOutlet = 'post-viewer';
